import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable2 = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns2 = [
    {
      prop: 'avg_min',
      label: i18n.t('production.unweighted'),
      minWidth: 110,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'avg_max',
      label: i18n.t('common_words.additional'),
      minWidth: 110,
      sortable: true,
      align: 'center',
    }
  ];

  return { Table };
};

export default configTable2;
